import React, { useEffect, useRef, useState } from 'react'
import { Link } from 'react-router-dom';
import * as XLSX from "xlsx";
import { Input, Label, Button, Card, CardBody, Col, Row, Table, Modal, ModalHeader, ModalBody } from 'reactstrap';
import Skeleton from "react-loading-skeleton";
import "../../assets/css/--component-agent.css"
import { addNewCampaignData, createCampaignFiles, getAllAgents, getPrompt, getSingleCampaign, UpdateCampaignInfo } from '../../helper/backend-methods';
import { showToast } from '../../components/Toast';
import { EmptyRow } from '../../components/EmptyState';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom'
import "../../assets/css/--component-agent.css"
import { formatBytes, normalizePhoneNumber } from '../../common';
import { decompressFromEncodedURIComponent } from "lz-string";
import moment from 'moment';

const UpdateCampaign = () => {
    const params = useParams();
    const [searchParams] = useSearchParams();
    const encoded = searchParams.get("data");
    const encoded_info = searchParams.get("campaign_info");
    const id = params.id;
    const history = useNavigate();
    const today = moment().format("YYYY-MM-DD");
    const [loading, setLoading] = useState(false);
    const [campaign, setCampaign] = useState([]);
    const [campaignInfo, setCampaignInfo] = useState(encoded_info ? JSON.parse(decompressFromEncodedURIComponent(encoded_info)) : null);
    const [prompts, setPrompts] = useState([]);
    const [agents, setAgents] = useState([])
    const [selectedAgent, setSelectedAgent] = useState({});
    const [selectedPrompt, setSelectedPrompt] = useState({ _id: 0, title: "", prompt: "", purpose: "" });
    const [headers, setHeaders] = useState([]);
    const [files, setFiles] = useState([]); // Newly uploaded files
    const [errors, setErrors] = useState({});
    const [viewModal, setViewModal] = useState(false);
    const [update, setUpdate] = useState(0);
    const excludeKeys = ['__v', '_id', 'campaignId', 'createdAt', 'updatedAt', 'is_called'];

    const [csvHeaders, setCsvHeaders] = useState([]);
    const [csvData, setCsvData] = useState([]);
    const [fieldMap, setFieldMap] = useState(encoded ? JSON.parse(decompressFromEncodedURIComponent(encoded)) : null);
    const [systemFields, setSystemFields] = useState(Object.keys(encoded ? JSON.parse(decompressFromEncodedURIComponent(encoded)) : null));
    const [showTable, setShowTable] = useState(false);
    const [mappedJson, setMappedJson] = useState([]);
    const [mappingObject, setMappingObject] = useState();
    const [customFields, setCustomFields] = useState(encoded ? JSON.parse(decompressFromEncodedURIComponent(encoded)) : null);
    const [rowErrors, setRowErrors] = useState([]);
    const fileInputRef = useRef(null);
    useEffect(() => {
        fetchSingleCampaign();
    }, [update])

    useEffect(() => {
        fetchAgents();
    }, [])

    const fetchAgents = () => {
        setLoading(true)
        setAgents([])
        getAllAgents().then((data) => {
            if (data.data.length) {
                setAgents(data.data ? data.data : [])
                setSelectedAgent(data.data[0])
                getPromptsHandler(data.data[0])
            }
            else {
                history("/create-new-agent")
                showToast("error", "Request Failed", "Please create an agent first.")
            }
            setLoading(false)
        }).catch((err) => {
            showToast("error", "Request Failed", err.message)
        })
    }

    const getPromptsHandler = (agent) => {
        setSelectedPrompt([]);
        getPrompt().then((data) => {
            if (data.data.length) {
                setPrompts(data.data)
                const selectedItem = data.data.find((item) => item._id === agent.promptId);
                setSelectedPrompt(selectedItem)
                // if (setSelected) setSelectedPrompt(data.data[0])
            }
            else {
                history("/create-new-prompt")
                showToast("error", "Request Failed", "Please create a prompt first.")
            }
        }).catch((err) => {
            showToast("error", "Request Failed", err.message)
        })
    }
    const handlePromptchange = (id) => {
        const selectedID = id;
        const selectedItem = prompts.find((item) => item._id === selectedID);
        setSelectedPrompt(selectedItem ? selectedItem : []);
    };
    const handleAgentchange = (id) => {
        const selectedID = id;
        const selectedItem = agents.find((item) => item._id === selectedID);
        setSelectedAgent(selectedItem ? selectedItem : []);
        const newSelectedPrompt = prompts.find((item) => item._id === selectedItem.promptId);
        setSelectedPrompt(newSelectedPrompt)
    };

    const fetchSingleCampaign = () => {
        setLoading(true)
        getSingleCampaign(id).then((data) => {
            if (data.data) {
                // console.log("customFields", customFields)
                // console.log("systemFields", systemFields)
                // console.log("fieldMap", fieldMap)
                // console.log("data", data)
                setCampaign(data.data);
                const Tableheaders = data.data.length
                    ? Object.keys(data.data[0]).filter((key) => !excludeKeys.includes(key))
                    : [];
                setHeaders(Tableheaders);
            }
            else {
                showToast("error", "Request Failed", data.message)
            }
            setLoading(false)
        }).catch((err) => {
            showToast("error", "Request Failed", err.message)
        })
    }
    const handleStartDateChange = (e) => {
        const selectedDate = e.target.value;

        if (moment(selectedDate).isBefore(moment(), 'day')) {
            // Reset invalid date
            setCampaignInfo((prev) => ({ ...prev, startDate: '', endDate: '' }));
        } else {
            setCampaignInfo((prev) => ({
                ...prev,
                startDate: selectedDate,
                endDate: '', // Reset end date on start change
            }));
        }
    };

    const handleEndDateChange = (e) => {
        setCampaignInfo({
            ...campaignInfo,
            endDate: e.target.value
        });
    };
    const handleStartTimeChange = (e) => {
        const selectedTime = e.target.value;

        setCampaignInfo((prev) => ({
            ...prev,
            startTime: selectedTime,
            endTime: '',
        }));
    };

    const handleEndTimeChange = (e) => {
        const selectedEndTime = e.target.value;
        setCampaignInfo((prev) => ({
            ...prev,
            endTime: selectedEndTime,
        }));
    };

    // File mapping started
    const handleFileUpload = (e) => {
        const error = { file: "" };
        const selectedFiles = Array.from(e.target.files);

        const isValid = selectedFiles.every(file => {
            const fileType = file.name.split(".").pop();
            return fileType && ["xlsx"].includes(fileType.toLowerCase());
        });

        if (!isValid) {
            console.log("invalid file")
            clearFiles();
            error.file = "Only .xlsx files are allowed";
            setErrors(error)
            return;
        }
        // setErrors({...errors, file:""})
        const validSizeFiles = selectedFiles.filter(file => {
            const fileType = file.name.split(".").pop();
            return fileType && ["xlsx"].includes(fileType.toLowerCase());
        });

        const formattedFiles = validSizeFiles.map(file =>
            Object.assign(file, { formattedSize: formatBytes(file.size) })
        );
        setFiles(prev => [...prev, ...formattedFiles]);

        validSizeFiles.forEach(file => {
            const reader = new FileReader();
            reader.onload = (evt) => {
                const bstr = evt.target?.result;
                const wb = XLSX.read(bstr, { type: "binary" });
                const wsname = wb.SheetNames[0];
                const ws = wb.Sheets[wsname];
                const data = XLSX.utils.sheet_to_json(ws, { header: 1 });
                const [headers, ...rows] = data;

                setCsvHeaders(prev => Array.from(new Set([...prev, ...headers])));
                setCsvData(prev => [
                    ...prev,
                    ...rows
                        .filter(row => row.some(cell => cell != null && String(cell).trim() !== ""))
                        .map(row =>
                            Object.fromEntries(headers.map((header, i) => [header, row[i] || ""]))
                        )
                ]);

                setShowTable(false);
            };
            reader.readAsBinaryString(file);
        });
    };

    const handleMappingChange = (sysField, csvField) => {
        setFieldMap((prev) => ({ ...prev, [sysField]: csvField }));
    };

    const handleProceed = () => {
        let flag = false;
        let error = { file: false, phone: false };
        const rowErrorsTemp = [];
        if (!files.length) {
            flag = true;
            error.file = "Please provide at least one csv file to map.";
        }
        const phoneField = systemFields.find(field => field.toLowerCase().includes("phone"));
        if (!fieldMap[phoneField]) {
            flag = true;
            error.phone = "Please map the phone number field.";
        }
        setErrors(error)
        const mapped = csvData.map((row, index) => {
            const mappedRow = {};
            let isValidRow = true;

            for (const sysField of systemFields) {
                let value = row[fieldMap[sysField] || ""] || "";

                if (sysField === phoneField) {
                    value = normalizePhoneNumber(value);
                    if (!value) {
                        rowErrorsTemp.push(index);
                        isValidRow = false;
                        break;
                    }
                }

                mappedRow[sysField] = value;
            }

            return isValidRow ? mappedRow : null;
        }).filter(Boolean);

        // if (rowErrorsTemp.length > 0) {
        //     flag = true;
        //     error.phone = `${rowErrorsTemp.length} row(s) have invalid phone numbers.`;
        // }

        if (!flag) {
            const mappingPairs = {};
            for (const sysField of systemFields) {
                if (fieldMap[sysField]) {
                    mappingPairs[sysField] = fieldMap[sysField];
                }
            }
            setMappedJson(mapped);
            setMappingObject(mappingPairs);
            setShowTable(true);
            console.log("Mapped JSON to send to backend:", mapped);
            console.log("Field mapping:", mappingPairs);
        }

        setRowErrors(rowErrorsTemp);
        setErrors(error);
    };
    // File mapping end

    const toCamelCaseKey = (key) => {
        return key.charAt(0).toLowerCase() + key.slice(1);
    }

    const handleSubmit = () => {
        setLoading(true)
        const leadsJSON = mappedJson.map(obj =>
            Object.fromEntries(
                Object.entries(obj).map(([key, value]) => [toCamelCaseKey(key), value])
            )
        );
        const formData = {
            campaignId: id,
            leads: leadsJSON,
        }
        addNewCampaignData(formData).then((data) => {
            if ((data.status === 201 || data.status === 200)) {
                let formDataFile = new FormData();
                formDataFile.append('campaignId', id);
                for (let file of files) {
                    formDataFile.append(`files`, file);
                }
                createCampaignFiles(formDataFile).then((data) => {
                    showToast("success", "Campaign Update", "Your campaign's data has been updated successfully.")
                    setLoading(false);
                    setViewModal(false)
                    setUpdate(prev => prev + 1);
                    // history('/campaigns')
                }).catch((e) => {
                    showToast("error", "Campaign Request Failed", "Your campaign could not be updated.")
                    setLoading(false);
                })
            } else {
                setLoading(false);
            }
        }).catch((e) => {
            showToast("error", "Campaign Request Failed", "Your campaign could not be updated.")
            setLoading(false);
        })
    }
    const handleSubmitInfo = () => {
        let flag = false;
        let error = { title: false, description: false, startDate: false, endDate: false };
        if (!campaignInfo.title || campaignInfo.title.replace(/\s/g, '').length < 1) {
            flag = true;
            error.title = "Please provide valid title";
        }
        if (!campaignInfo.description || campaignInfo.description.replace(/\s/g, '').length < 1) {
            flag = true;
            error.description = "Please provide campaign description";
        }
        if (!campaignInfo.startDate || campaignInfo.startDate.replace(/\s/g, '').length < 1) {
            flag = true;
            error.startDate = "Please provide campaign's start date";
        }
        if (!campaignInfo.endDate || campaignInfo.endDate.replace(/\s/g, '').length < 1) {
            flag = true;
            error.endDate = "Please provide campaign's end date";
        }
        if (!campaignInfo.startTime || campaignInfo.startTime.replace(/\s/g, '').length < 1) {
            flag = true;
            error.startTime = "Please provide preferred start time";
        }
        if (!campaignInfo.endTime || campaignInfo.endTime.replace(/\s/g, '').length < 1) {
            flag = true;
            error.endTime = "Please provide preferred end time";
        }
        if (campaignInfo.startTime && campaignInfo.endTime) {
            const start = moment(campaignInfo.startTime, "HH:mm");
            const end = moment(campaignInfo.endTime, "HH:mm");

            if (end.isBefore(start)) {
                flag = true;
                error.endTime = "End time should be greater than start time";
            }
        }
        setErrors(error)
        if (!flag) {
            setLoading(true)
            const formData = {
                campaignId: id,
                name: campaignInfo.title,
                description: campaignInfo.description,
                startDate: campaignInfo.startDate,
                endDate: campaignInfo.endDate,
                preferredTime: {
                    from: campaignInfo.startTime,
                    to: campaignInfo.endTime
                },
            }
            UpdateCampaignInfo(formData).then((data) => {
                showToast("success", "Campaign Info Updated", "Your campaign's info has been updated successfully.")
                setLoading(false);
                setViewModal(false)
                setUpdate(prev => prev + 1);
                history('/campaigns')
            }).catch((e) => {
                showToast("error", "Campaign Request Failed", "Your campaign info could not be updated.")
                setLoading(false);
            })
        }
    }

    const clearFiles = () => {
        setFiles([]);
        setCsvHeaders([]);
        setCsvData([]);
        setShowTable(false);
        if (fileInputRef.current) {
            fileInputRef.current.value = "";
        }
    }

    return (
        <div className="content-page">
            <div className="content">
                <div className="container-fluid">
                    <div className="py-3 row">
                        <div className="col-12">
                            <Row className="my-2 align-items-center">
                                <Col md={6}>
                                    <h4>Update Campaign</h4>
                                    <p className='text-muted fs-12'>Edit the campaign details</p>
                                </Col>
                                <Col md={6} className='text-right'>
                                    <Link to={"/campaigns"} className="px-4 py-2 me-2 rounded bg-white border-0 text-primary"><i className="ri-arrow-left-line"></i> Back</Link>
                                </Col>
                            </Row>
                        </div>
                    </div>
                    <Row>
                        <Col md={12}>
                            <Card className='bg-white rounded-2'>
                                <CardBody>
                                    <Row>
                                        <Col md={12} className='mb-4'>
                                            <Label htmlFor="prompt" className="text-left text-black font-bold"> Campaign Name </Label>
                                            <input id="prompt" className='custom-input form-control rounded border-0 py-2' type="text" value={campaignInfo.title} onChange={(e) => { setCampaignInfo((prev) => { return { ...prev, title: e.target.value } }); }} />
                                            {errors.title && <p className="invalid-feedback">{errors.title}</p>}
                                        </Col>
                                        <Col md={12} className='mb-4'>
                                            <Label htmlFor="prompt" className="text-left text-black font-bold"> Campaign Description </Label>
                                            <textarea value={campaignInfo.description} onChange={(e) => { setCampaignInfo((prev) => { return { ...prev, description: e.target.value } }); }} style={{ width: "100%", minHeight: "100px", maxHeight: "150px" }} className='fs-16 rounded p-2 custom-textarea' ></textarea>
                                            {errors.description && <p className="invalid-feedback">{errors.description}</p>}
                                        </Col>
                                        <Col md={6} className="mb-4">
                                            <Label htmlFor="startDate" className="text-left text-black font-bold">Campaign Start Date </Label>
                                            <input type="date" id="startDate" className={`form-control custom-input`} min={today} value={moment.utc(campaignInfo.startDate).local().format("YYYY-MM-DD")} onChange={handleStartDateChange} />
                                            {errors.startDate && <p className="invalid-feedback">{errors.startDate}</p>}
                                        </Col>
                                        <Col md={6} className="mb-4">
                                            <Label htmlFor="endDate" className="text-left text-black font-bold">Campaign End Date </Label>
                                            <input type="date" id="endDate" className={`form-control custom-input`} min={campaignInfo.startDate || ''} value={moment.utc(campaignInfo.endDate).local().format("YYYY-MM-DD")} onChange={handleEndDateChange} disabled={!campaignInfo.startDate} />
                                            {errors.endDate && <p className="invalid-feedback">{errors.endDate}</p>}
                                        </Col>
                                        <Col md={6} className="mb-4">
                                            <Label htmlFor="startTime" className="text-left text-black font-bold">Preferred Start Time</Label>
                                            <input
                                                type="time"
                                                id="startTime"
                                                className="form-control custom-input"
                                                value={campaignInfo.startTime}
                                                onChange={handleStartTimeChange}
                                                disabled={!campaignInfo.startDate}
                                            />
                                            {errors.startTime && <p className="invalid-feedback">{errors.startTime}</p>}
                                        </Col>

                                        <Col md={6} className="mb-4">
                                            <Label htmlFor="endTime" className="text-left text-black font-bold">Preferred End Time</Label>
                                            <input
                                                type="time"
                                                id="endTime"
                                                className="form-control custom-input"
                                                value={campaignInfo.endTime}
                                                onChange={handleEndTimeChange}
                                                disabled={!campaignInfo.startTime}
                                            />
                                            {errors.endTime && <p className="invalid-feedback">{errors.endTime}</p>}
                                        </Col>
                                        <Col md={12} className='text-right'>
                                            <Button disabled={loading} onClick={() => { handleSubmitInfo() }} className="px-4 py-2 rounded linear-gradient-btn">{loading ? "Please Wait" : "Update Campaign Details"}</Button>
                                        </Col>
                                    </Row>
                                    {/* <Row>
                                        <Col md={12}>
                                            <h4 className='mb-4'>Select An Agent</h4>
                                            <Row>
                                                <Col md={12} className='mb-4'>
                                                    <Label htmlFor="agent" className="text-left text-black font-bold"> Agent </Label>
                                                    <Input id="agent" className='custom-select rounded border-0 py-2' type="select" value={selectedAgent ? selectedAgent._id : ""} onChange={(e) => { handleAgentchange(e.target.value) }} >
                                                        {agents.map((item) => (
                                                            <option key={item._id} value={item._id}>
                                                                {item.name}
                                                            </option>
                                                        ))}
                                                    </Input>
                                                </Col>
                                            </Row>
                                            <h4 className='mb-4'>Agent Prompt & Goals</h4>
                                            <Row>
                                                <Col md={12} className='mb-4'>
                                                    <Input id="prompt" disabled={true} className='custom-select rounded border-0 py-2' type="text" value={(selectedPrompt && selectedPrompt.title) || ""} onChange={(e) => { handlePromptchange(e.target.value) }} />
                                                </Col>
                                                <Col md={12} className='mb-4'>
                                                    <small className='d-block fs-14 mb-2'><i className="ri-information-line text-primary"></i> You can use dynamic fields in your prompt for example [{[...new Set(systemFields)].join("], [")}]</small>
                                                    <textarea disabled={false} value={selectedPrompt ? selectedPrompt.prompt : ""} onChange={(e) => { setSelectedPrompt((prev) => { return { ...prev, prompt: e.target.value } }); }} className='fs-16 rounded p-2 custom-textarea' ></textarea>
                                                </Col>
                                                <Col md={12} className='mb-4'>
                                                    <input disabled={true} type="text" id="purpose" className={`form-control custom-input`} value={(selectedPrompt && selectedPrompt.purpose) || ""} onChange={(e) => { setSelectedPrompt((prev) => { return { ...prev, purpose: e.target.value } }); }} />
                                                </Col>
                                            </Row>
                                        </Col>
                                        <Col md={12} className='text-right'>
                                            <Button disabled={loading} onClick={() => { handleSubmit() }} className="px-4 py-2 rounded linear-gradient-btn">{loading ? "Please Wait" : "Update Campaign Details"}</Button>
                                        </Col>
                                    </Row> */}
                                </CardBody>
                            </Card>
                            <Card className='bg-white rounded-2 mt-4'>
                                <CardBody>
                                    <Row>
                                        <Col md={6} className='mb-4'>
                                            <h4>Update Campaign Data</h4>
                                            <p className='text-muted fs-12'>Edit the call list for the campaign</p>
                                        </Col>
                                        <Col md={6} className='text-right mb-4'>
                                            <Button disabled={loading} onClick={() => { setViewModal(true) }} className="px-4 py-2 rounded linear-gradient-btn"><i className="ri-add-line"></i> Add New Data</Button>
                                        </Col>
                                        <Col md={12} className=''>
                                            <Table hover responsive className='border-rounded'>
                                                <thead>
                                                    <tr>
                                                        {headers.map((header) => (
                                                            <th style={{ background: "#f1f1f1" }} key={header}>{header.charAt(0).toUpperCase() + header.slice(1)}</th>
                                                        ))}
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {
                                                        loading ?
                                                            [...Array(30)].map((a, i) => {
                                                                return <tr key={i}>
                                                                    <td className="fs-12"><Skeleton height={12} width={80} /></td>
                                                                    <td className="fs-12"><Skeleton height={12} width={90} /></td>
                                                                    <td className="fs-12"><Skeleton height={12} width={80} /></td>
                                                                    <td className="fs-12"><Skeleton height={12} width={80} /></td>
                                                                    <td className="fs-12"><Skeleton height={12} width={80} /></td>
                                                                </tr>
                                                            }) :
                                                            campaign.length === 0 ?
                                                                <EmptyRow colSpan={9} icon="ri-contacts-line" title="No contacts in this campaign" body="Upload a contact list to get this campaign running." /> :
                                                                campaign.map((item, i) => (
                                                                    <tr key={i}>
                                                                        {headers.map((key) => (
                                                                            <td className="fs-12 fw-500" key={key}>{item[key]}</td>
                                                                        ))}
                                                                    </tr>
                                                                ))

                                                    }
                                                </tbody>
                                            </Table>
                                        </Col>
                                    </Row>
                                </CardBody>
                            </Card>
                            <Modal isOpen={viewModal} toggle={() => { setViewModal(false) }} centered={true} size='xl'>
                                <ModalHeader toggle={() => setViewModal(false)}>
                                    <small>Upload More Data</small>
                                    <small className='d-block fs-14 mt-2'><i className="ri-information-line text-primary"></i> Your file must contain these fields ({[...new Set(Object.values(customFields))].join(", ")})</small>
                                </ModalHeader>
                                <ModalBody>
                                    <p className="fw-light mb-0 font-size-14 mb-1">Please browse the file to add more data</p>
                                    <input type="file" accept=".csv,.xlsx" className='form-control' multiple onChange={handleFileUpload} ref={fileInputRef} />
                                    {files.length ? <p onClick={clearFiles} className='text-right'><small className='text-danger cursor-pointer mb-3'>Clear File</small></p> : null}
                                    {errors.file && <p className="invalid-feedback text-left">{errors.file}</p>}
                                    {csvHeaders.length > 0 && (
                                        <>
                                            <Row className="text-center mt-3">
                                                <Col>
                                                    <button className="btn btn-primary mr-2 linear-gradient-btn" onClick={handleProceed}>Proceed</button>
                                                </Col>
                                            </Row>
                                        </>
                                    )}
                                    {showTable && mappedJson.length > 0 && (
                                        <div className="mt-4">
                                            <h5>Calls List Preview</h5>
                                            <div className="table-responsive">
                                                <table className="table table-bordered">
                                                    <thead className="table-light">
                                                        <tr>
                                                            {systemFields.map((field, index) => (
                                                                <th key={index} className='text-capitalize'>{field}</th>
                                                            ))}
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {mappedJson.map((row, rowIndex) => (
                                                            <tr key={rowIndex}>
                                                                {systemFields.map((field, colIndex) => (
                                                                    <td key={colIndex}>{row[field]}</td>
                                                                ))}
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    )}
                                    {
                                        showTable ?
                                            <Row>
                                                <Col md={12} className='text-right'>
                                                    <Button disabled={loading} onClick={() => { handleSubmit() }} className="px-4 py-2 rounded linear-gradient-btn">{loading ? "Please Wait" : "Update Campaign Data"}</Button>
                                                </Col>
                                            </Row> : null
                                    }
                                </ModalBody>
                            </Modal>
                        </Col>
                    </Row>
                </div>
            </div>
        </div>
    )
}

export default UpdateCampaign
